import styled from "@emotion/styled";
import { LocalDateTime } from "@js-joda/core";
import React from "react";
import ChatAvatar from "../ChatRoom/ChatAvatar";
import { getLastMessageDateTimeString } from "../utils/chatUtils";

interface ChatCardProps {
  contactName: string;
  agencyName: string;
  message: string;
  unreadMessagesCount: number;
  lastMessageDateTime: LocalDateTime;
  onClick: () => void;
}

const ChatCard = (props: ChatCardProps) => {
  return (
    <ChatCard.Root onClick={props.onClick}>
      <ChatCard.Row>
        <ChatCard.Leading>
          <ChatAvatar url={null} size={40} />
        </ChatCard.Leading>
        <ChatCard.Content>
          <ChatCard.Title>{props.message}</ChatCard.Title>
          <ChatCard.Subtitle>
            {props.contactName} - {props.agencyName}
          </ChatCard.Subtitle>
        </ChatCard.Content>
      </ChatCard.Row>
      <ChatCard.Trailing>
        {getLastMessageDateTimeString(props.lastMessageDateTime)}
        {props.unreadMessagesCount > 0 ? (
          <ChatCard.UnreadMessagesCount>{props.unreadMessagesCount}</ChatCard.UnreadMessagesCount>
        ) : null}
      </ChatCard.Trailing>
    </ChatCard.Root>
  );
};

ChatCard.Root = styled.div`
  box-shadow: 0px 4px 16px rgba(123, 130, 141, 0.1);
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 14px 12px;
  border-radius: 16px;
  background-color: white;
  min-height: 48px;
`;

ChatCard.Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

ChatCard.Title = styled.div`
  font-weight: 700;
  font-size: 14px;
`;

ChatCard.Subtitle = styled.div`
  font-weight: 500;
  font-size: 12px;
`;

ChatCard.Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
`;

ChatCard.Trailing = styled.div`
  display: flex;
  flex-direction: column;
  padding: 3px;
  font-weight: 400;
  font-size: 12px;
  justify-content: center;
  align-items: flex-end;
  justify-content: space-between;
`;

ChatCard.Leading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

ChatCard.UnreadMessagesCount = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2px;
  gap: 8px;
  width: 14px;
  background: #3077eb;
  border-radius: 50%;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #ffffff;
`;

export default ChatCard;
